import type { CookieClient } from '@/scopes/common/domain/types';
import { getCookieValue } from './cookieUtils';

function createCookieClient(): CookieClient {
  return {
    get(name: string): string | null {
      return getCookieValue(name);
    },
  };
}

export default createCookieClient();
